import React from 'react';
import ReportingDonationsTopDonorsPage from '../components/ReportingDonationsTopDonorsPage';

const ReportingDonationsTopDonorsApp = (props) => (
  <ReportingDonationsTopDonorsPage {...props} />
);

export default ReportingDonationsTopDonorsApp;
